import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/notification/importer/notificationImporterActions';

export default importerReducers(actions);
